<template>
    <div class="projects">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4">
                <div class="text-left mt-3 ml-5 mb-4">
                    <a-icon class="mr-1" type="arrow-left" />
                    <span class="go-back" @click="goBack">Go Back</span>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-8" v-if="loading">
                        <div class="mt-6 pt-3 text-center">
                            <hollow-dots-spinner
                                :animation-duration="1000"
                                :dot-size="15"
                                :dots-num="5"
                                color="#20409a"
                                class="mx-auto"
                            />
                            <br />
                            <p>Loading...</p>
                        </div>
                    </div>
                    <div v-else class="col-sm-12 col-md-12 col-lg-8">
                        <div class="row">
                            <h3 class="font-weight-bolder kova-text text-left ml-4">
                                Jobs
                            </h3>
                        </div>
                        <div>
                            <div class="pl-2 bg-light add-rounded border projects-container scrollbar">
                                <div class="d-flex justify-content-around flex-wrap" v-if="ongoingJobs.length">
                                    <div :key="job.ID + 'ac'" v-for="job in ongoingJobs">
                                        <JobPost :project="job" />
                                    </div>
                                </div>
                                <div class="d-flex justify-content-around flex-wrap text-center py-3" v-else>
                                    <p class="mb-0">You have no ongoing jobs yet</p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4 mb-5">
                            <div class="pt-4">
                                <h4 class="text-left kova-text font-weight-bolder">
                                    Completed Projects
                                </h4>
                            </div>
                            <div class="p-4 bg-light border shadow-sm rounded" v-if="completedJobs.length">
                                <div :key="i" v-for="(work, i) in completedJobs">
                                    <job :project="work" status="completed" />
                                    <hr v-if="i + 1 !== completedJobs.length" />
                                </div>
                            </div>
                            <div class="p-4 bg-light border shadow-sm rounded text-center" v-else>
                                <p>You have not completed any projects yet</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4 px-0">
                        <div class="pt-2 mt-1 ml-lg-4" style="position: sticky; top: 75px;">
                            <!-- Notifications -->
                            <Notifications />
                            <!-- Messages -->
                            <!-- <Messages /> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import JobPost from '@/components/JobPost.vue';
import Notifications from '@/components/Notifications.vue';
// import Messages from '@/components/Messages.vue';

import ProfileMixin from '../mixins/profile';

export default {
    name: 'projects',
    mixins: [ProfileMixin],
    components: {
        Navbar,
        Footer,
        JobPost,
        Notifications,
        // Messages,
    },
    data() {
        return {
            profileData: {},
            loading: true,
        };
    },
    computed: {
        ongoingJobs() {
            return (this.profileData || {}).MyProjects || [];
        },
    },
    methods: {
        styleScroll: function() {
            let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            let isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
            let scrollbarDiv = document.querySelector('.scrollbar');
            if (!isChrome && !isSafari) {
                scrollbarDiv.innerHTML = 'You need Webkit browser to run this code';
            }
        },
        goBack() {
            this.$router.go(-1);
        },
    },
    async mounted() {
        await Promise.all([this.getProfile(), this.getAllSettings()]);
        this.styleScroll();
        this.loading = false;
    },
};
</script>

<style scoped>
.kova-text {
    color: #20409a;
}
.bg-kovatek {
    background-color: #20409a;
}
.projects-container {
    max-height: 530px;
    /* overflow-y: hidden;
  }

  .projects-container:hover { */
    overflow-y: scroll;
}
.add-rounded {
    border-radius: 10px;
}

.kova-circle {
    height: 80px;
    width: 80px;
    border-radius: 50%;
    background-color: #20409a;
    color: #fff;
    font-size: 25px;
    font-weight: bolder;
    line-height: 80px;
}
.id {
    width: 100px;
    height: 20px;
    background-color: #7cd192;
    border-radius: 5px;
}
.ctrl-ellipsis {
    font-size: 20px;
    color: #7cd192;
}
.bid-color {
    color: #7cd192;
}
.projects-lists {
    width: 260px;
}
.ctrl-size {
    font-size: 11px;
}
.ctrl-size-2 {
    font-size: 12px;
}

/* total width */

/* set button(top and bottom of the scrollbar) */
.scrollbar::-webkit-scrollbar-button {
    display: none;
}

@media screen and (min-width: 992px) and (max-width: 1325px) {
    .projects-lists {
        width: 300px;
    }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
    .employer-name {
        font-size: 18px;
    }
    .img-height {
        width: 70px;
        height: 70px;
    }
    .projects-lists {
        width: 260px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
}

@media screen and (max-width: 767px) {
    .float-text {
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6 {
        float: left;
    }
}
</style>
